import { a as r } from "./a-callable.js";
import { i as a } from "./is-null-or-undefined.js";
var o = function o(_o, e) {
  var i = _o[e];
  return a(i) ? void 0 : r(i);
};
export { o as g };